import ListadoFestivosImpl from "components/festivos/ListadoFestivosImpl";
import React from "react";

const ViewFestivos = () => {
  return (
    <>
      <ListadoFestivosImpl></ListadoFestivosImpl>
    </>
  );
};

export default ViewFestivos;
